import axios from 'axios'
export default {
  login (params) {
    return axios.post('/api/rendering/admin/base/login', params)
  },
  logout (params) {
    return axios.post('/api/rendering/admin/base/logout', params)
    // return axios.post('/api/rendering/admin/logout', params)
  },
  loginVerifyCode (params) {
    return axios.post('/api/rendering/admin/base/aquireLoginVerifycode', params)
  },
  /**
   * 判断是否首次登录
   * @param {string} userName
   */
  isInitialLogin () {
    return axios.get('/api/rendering/admin/base/user/isFirstLogin')
  },
}
